import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./bao-dialog";
import template from "./translate-dialog.html";
function TranslateDialogViewModel(obs1, obs2, obs3, obs4, obs5) {
    var self = this;
    self.Bao = Bao;
    self.AvailableLanguages = ko.observableArray([]);
    self.Language1 = ko.observable(obs1());
    self.Language2 = ko.observable(obs2());
    self.Language3 = ko.observable(obs3());
    self.Language4 = ko.observable(obs4());
    self.Language5 = ko.observable(obs5());
    self.ApplyValues = function () {
        obs1(self.Language1());
        obs2(self.Language2());
        obs3(self.Language3());
        obs4(self.Language4());
        obs5(self.Language5());
    };
    self.Open = function () {
        var def = $.Deferred();
        def.resolve();
        var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                self.ApplyValues();
                dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                dialog.Close();
            },
            Enabled: ko.observable(true)
            }]);
        self.AvailableLanguages(Bao.Session.AvailableLanguages());
        dialog.ViewModel(self);
        dialog.Template(template);
        dialog.Open();
        return def.promise();
    };
}
export default TranslateDialogViewModel;